"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var KsysRequest_1 = require("../KsysRequest");
var ExternalApiExecute = /** @class */ (function (_super) {
    __extends(ExternalApiExecute, _super);
    function ExternalApiExecute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getExplicitEndpoint = function () { return '/portal/externalApi/execute'; };
        return _this;
    }
    Object.defineProperty(ExternalApiExecute.prototype, "endpointConfiguration", {
        get: function () {
            return this.getEndpointConfiguration("portal", "ExternalApiExecute");
        },
        enumerable: true,
        configurable: true
    });
    return ExternalApiExecute;
}(KsysRequest_1.KsysRequest));
exports.ExternalApiExecute = ExternalApiExecute;
//# sourceMappingURL=ExternalApiExecute.js.map